import classNames from 'classnames';
import Image, { type StaticImageData } from 'next/image';
import type { ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import styles from './UpsellFeatureList.module.scss';

export type UpsellFeatureVariant = 'default' | 'compact';

export type UpsellFeature = {
  body: ReactNode;
  src: StaticImageData;
  title: ReactNode;
  // Strips the default thumbnail framing (border/radius) for images that ship their own card framing, keeping only the drop shadow.
  unframedThumbnail?: boolean;
};

type Props = UpsellFeature & {
  variant?: UpsellFeatureVariant;
};

export default function UpsellFeatureRow({ body, src, title, unframedThumbnail, variant = 'default' }: Props) {
  const isCompact = variant === 'compact';
  const thumbnailSize = isCompact ? 72 : 84;

  return (
    <li className={styles.row}>
      <Image
        alt=""
        className={classNames(styles.thumbnail, { [styles.thumbnailCompact]: isCompact, [styles.thumbnailUnframed]: unframedThumbnail })}
        height={thumbnailSize}
        src={src}
        width={thumbnailSize}
      />
      <div className={styles.copy}>
        <Typography className={classNames(styles.rowTitle, { [styles.rowTitleCompact]: isCompact })} component="p" variant="text200bold">
          {title}
        </Typography>
        <Typography className={styles.rowBody} color="secondary" component="p" variant={isCompact ? 'text100' : 'text150'}>
          {body}
        </Typography>
      </div>
    </li>
  );
}
